var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-button',{staticClass:"mr-2",on:{"click":_setup.openModal}},[_vm._v(_vm._s(`Batch Approve (${_setup.selectedLength})`))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }